export default __webpack_public_path__ + "static/media/LoginBackground.b0c8cfe0.png";